import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CookieService } from 'ngx-cookie-service'
import { environment } from '../../../environments/environment'

@Injectable()
export class TelemetriaService {
    constructor(
        private httpClient: HttpClient,
        private cookieService: CookieService
    ) {}

    cadastrarTelemetria(path) {
        const url = `${environment.collectJsonApiBaseUrl}/telemetria`;
        const body = { path };

        const jwt = this.cookieService.get('jwt')
        const headers = { Authorization: `Bearer ${jwt}` }
        return this.httpClient.post(url, body, { headers });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/telemetria.service.ts